import React from 'react'
import {Auth} from 'aws-amplify';
import axios from "axios";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Messages} from "primereact/messages";
import {Toolbar} from "primereact/toolbar";

class UpdateFarbabschlaege extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isFileUploaded: false,
            dataTableUploadInProgress: false,
            dataTableUploadProgress: 0.0,
            farbabschlaege: [],
            selectedEntry: null,
            displayDialog: false,
            versions: [],
            isLoading: false
        };

        this.onCarSelect = this.onCarSelect.bind(this);

        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    }

    componentDidMount() {
        //get the current values
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };

                axios.get(process.env.REACT_APP_IUCB_FARBABSCHLAEGE_ENDPOINT, axiosConfig)
                    .then(result => {
                        if(result.data && result.data.length > 0) {
                            this.setState({farbabschlaege: result.data});
                        }
                    })
                    .catch (err => {
                        console.log(err);
                    });
                axios.get(process.env.REACT_APP_IUCB_FARBABSCHLAEGE_VERSIONS_ENDPOINT, axiosConfig)
                    .then(result => {
                        this.setState({versions: result.data});
                    })
                    .catch (err => {
                        console.log(err);
                    });
            })
            .catch (err => {
                console.log(err);
            });
    }

    onCarSelect(e){
        this.newEntry = false;
        this.setState({
            displayDialog:true,
            entry: Object.assign({}, e.data)
        });
    }

    addNew = () => {
        this.newEntry = true;
        this.setState({
            entry: {selector:'', farbcode: '', farbabschlag: '', farbe: ''},
            displayDialog: true
        });
    };

    save = () => {
        let farbabschlaege = this.state.farbabschlaege;
        if(this.newEntry)
            farbabschlaege.push(this.state.entry);
        else
            farbabschlaege[this.findSelectedCarIndex()] = this.state.entry;

        this.setState({farbabschlaege:farbabschlaege, selectedEntry:null, entry: null, displayDialog:false});
    };

    findSelectedCarIndex() {
        return this.state.farbabschlaege.indexOf(this.state.selectedEntry);
    }

    updateProperty(property, value) {
        let car = this.state.entry;
        car[property] = value;
        this.setState({entry: car});
    }

    delete() {
        let index = this.findSelectedCarIndex();
        this.setState({
            farbabschlaege: this.state.farbabschlaege.filter((val,i) => i !== index),
            selectedEntry: null,
            entry: null,
            displayDialog: false});
    }

    updateValues = () => {
        //update values by JSON
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };

                const data = {
                    updated_values: this.state.farbabschlaege
                };
                this.setState({isLoading: true});
                axios.post(process.env.REACT_APP_IUCB_FARBABSCHLAEGE_ENDPOINT, data, axiosConfig)
                    .then(result => {
                        this.messages.show({severity: 'success', summary: 'Success', detail: 'Values updated.'});
                        this.setState({isLoading: false});
                    })
                    .catch (err => {
                        this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                        this.setState({isLoading: false});
                    })
            })
            .catch (err => {
                console.log(err);
            });

    };

    onFileChange = (files) => {
        const selectedFile = files[0];
        if (!selectedFile) {
            return;
        }
        //upload to endpoint
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };
                const params = {
                    file_identifier: 'farbabschlag_tabelle'
                };

                //retrive pre-signed URL
                axios.post(process.env.REACT_APP_IUCB_UPLOAD_ENDPOINT, params, axiosConfig)
                    .then(result => {
                        const url = result.data.upload_url;
                        // after recieving the signed URL an upload via put is possible
                        const axiosUploadConfig = {
                            headers: {'content-disposition': 'Attachment', 'Content-Type': selectedFile.type},
                            onUploadProgress: (progressEvent) => {
                                const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                                if (totalLength !== null) {
                                    this.setState({dataTableUploadProgress: Math.round((progressEvent.loaded * 100) / totalLength)});
                                }
                            }
                        };
                        axios.put(url, selectedFile, axiosUploadConfig)
                            .then(result => {
                                this.messages.show({severity: 'success', summary: 'Success', detail: 'File is completely uploaded!'});

                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0,
                                    isFileUploaded: true
                                });
                            })
                            .catch(err => {
                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0
                                });
                                this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                            });
                    })
                    .catch(err => {
                        console.log(err);
                    })
            })
            .catch (err => {
                console.log(err);
            });
    };

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <Button type="button" className="p-mr-2 p-d-inline-block" label="Add" icon="pi pi-plus" onClick={() => this.addNew()}/>
            </React.Fragment>
        )
    }

    render () {
        let paginatorLeft = <Button icon="pi pi-refresh"/>;
        let paginatorRight = <Button icon="pi pi-cloud-upload" />;


        let dialogFooter = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Delete" icon="pi pi-times" onClick={() => this.delete()}/>
            <Button label="Save" icon="pi pi-check" onClick={() => this.save()}/>
        </div>;

        return (
            <main className="o-page-wrap">
                <div>
                    <h1>Farbabschläge</h1>
                    <p>Please use the table or the file upload function to update the values. If you provide a CSV file, please refresh the page to see the changes.</p>
                    <h2>Current Values</h2>

                    <DataTable value={this.state.farbabschlaege} style={{width: '100%'}} scrollable={true}
                               paginator={true} paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}
                               selectionMode="single" selection={this.state.selectedEntry}
                               onSelectionChange={e => this.setState({selectedEntry: e.value})}
                               onRowSelect={this.onCarSelect}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="selector" header="MBV Selector" style={{width:'100px'}} filter={true} sortable={true}/>
                        <Column field="farbcode" header="Color Code" style={{width:'100px'}} />
                        <Column field="farbabschlag" header="Color Modifier" style={{width:'100px'}} />
                        <Column field="farbe" header="Color" style={{width:'100px'}} />
                    </DataTable>

                    <Toolbar className="p-mb-4" left={this.leftToolbarTemplate} ></Toolbar>

                    <br />
                    <button type="button" className="c-btn" onClick={ () => this.updateValues() }
                            disabled={this.state.isLoading}>
                        <span className="c-btn__text">Save and Update</span>
                        {this.state.isLoading ?
                            <div className="c-spinner c-spinner--small">
                                <svg>
                                    <circle className="c-spinner__indicator" cx="9" cy="9" r="8" fill="none"/>
                                </svg>
                            </div>
                            : null
                        }
                    </button>

                    <Messages ref={(el) => this.messages = el}></Messages>

                    <Dialog visible={this.state.displayDialog} width="300px" header="Entry Details" modal={true} footer={dialogFooter} onHide={() => this.setState({displayDialog: false})}>
                        {
                            this.state.entry &&

                            <div className="p-grid p-fluid">
                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="vin">MBV Selector</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="vin" onChange={(e) => {this.updateProperty('selector', e.target.value)}} value={this.state.entry.selector}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="farbcode">Color Code</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="farbcode" onChange={(e) => {this.updateProperty('farbcode', e.target.value)}} value={this.state.entry.farbcode}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="farbabschlag">Color Modifier</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="farbabschlag" onChange={(e) => {this.updateProperty('farbabschlag', e.target.value)}} value={this.state.entry.farbabschlag}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="color">Color</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="color" onChange={(e) => {this.updateProperty('farbe', e.target.value)}} value={this.state.entry.farbe}/>
                                </div>
                            </div>
                        }
                    </Dialog>


                    <h2>Upload Values as CSV</h2>
                    <p>Please upload a CSV file with the same structure as the table above.</p>
                    <label htmlFor="file-upload" className="c-upload"
                           data-mouseover-text="This is the mouseover variant of the upload container">
                        <input className="c-upload__input" type="file" id="file-upload" onChange={ (e) => this.onFileChange(e.target.files) } />

                        <p className="c-upload__description">
                            <span>Click on this container for file uploads</span>
                            <span>or</span>
                        </p>

                        <div className="c-upload__actions">
                            <label className="c-upload__button  c-btn" htmlFor="file-upload">
                                <span>click here</span>
                            </label>
                        </div>
                    </label>
                    <h2>Versions</h2>
                    <DataTable value={this.state.versions} style={{width: '100%'}}
                               paginator={true}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="filename" header="Filename" style={{width:'100px'}} />
                        <Column field="version_id" header="Version ID" style={{width:'100px'}} />
                        <Column field="content_length" header="File Size (Bytes)" style={{width:'100px'}} />
                        <Column field="last_modified" header="Last Modified" style={{width:'100px'}} />
                    </DataTable>
                </div>
            </main>
        )
    }
}
export default UpdateFarbabschlaege;
